<template>
  <div>
    <Header></Header>
    <div class="banner"><img src="../assets/img/joinUS/banner.jpg" alt=""></div>
    <div class="content">
      <div class="service">
        <div class="title"><span>鲨鱼公园优势</span></div>
        <div class="img"><img src="../assets/img/joinUS/advantage.jpg" alt=""></div>
      </div>
      <div class="service">
        <div class="title"><span>全面支持体系</span></div>
        <div class="img"><img src="../assets/img/joinUS/support.jpg" alt=""></div>
      </div>
      <div class="service">
        <div class="title"><span>六大服务体系</span></div>
        <div class="img"><img src="../assets/img/joinUS/7.jpg" alt=""></div>
<!--        <div class="six">-->
<!--          <div><img src="../assets/img/joinUS/1.jpg" alt=""></div>-->
<!--          <div><img src="../assets/img/joinUS/2.jpg" alt=""></div>-->
<!--          <div><img src="../assets/img/joinUS/3.jpg" alt=""></div>-->
<!--        </div>-->
<!--        <div class="six">-->
<!--          <div><img src="../assets/img/joinUS/4.jpg" alt=""></div>-->
<!--          <div><img src="../assets/img/joinUS/5.jpg" alt=""></div>-->
<!--          <div><img src="../assets/img/joinUS/6.jpg" alt=""></div>-->
<!--        </div>-->
      </div>
      <div class="service">
        <div class="title"><span>我们的优势</span></div>
        <div><img src="../assets/img/joinUS/9.jpg" alt=""></div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'

export default {
  name: 'JoinUS',
  components: {Header, Footer},
  data () {
    return {
      msg: 'JoinUs'
    }
  }
}
</script>
<style>
  .content {
    width: 80%;
    height: auto;
    margin:0 auto;
    text-align: center;
    margin-top:2em;
  }

  /*.service{*/
  /*  width:80%;*/
  /*  height:auto;*/
  /*  margin:0 auto;*/
  /*  text-align:center;*/
  /*}*/

  .title {
    margin: 0 auto;
    text-align: center;
  }

  .title span {
    font-size: 2em;
    font-weight: bold;
    letter-spacing: 0.1em;
  }

  .service{
    width:80%;
    margin:0 auto;
    text-align: center;
    margin-bottom: 3em;
  }
  .img{
    margin-top:2em;
  }
  .img img{
    width:100%;
  }

  /*.six{*/
  /*  margin:0 auto;*/
  /*  text-align: center;*/
  /*}*/
  /*.six div{*/
  /*  float: left;*/
  /*  padding:0 5px 0 5px;*/
  /*}*/
</style>
